import React, {useEffect} from "react";
import { Divider, Col } from "antd";
import Back from "../../../components/User/Public/Home/Back";
import { FECHA_JORNADA_ELECTORAL } from "../../../utils/constanst";

const Glosario = () => {
  function toTop() {
    window.scrollTo(0, 0);
}

  useEffect(() => {
    toTop();
  }, []);
  
  return (
    <div>

      <Back /> <br /> <br />

      {/* Letras */}
      <div className="vinculoGlosario">
        <a href="#letra_A">A</a>
        <a href="#letra_C">C</a>
        <a href="#letra_D">D</a>
        <a href="#letra_E">E</a>
        <a href="#letra_F">F</a>
        <a href="#letra_G">G</a>
        <a href="#letra_I">I</a>
        <a href="#letra_J">J</a>
        <a href="#letra_L">L</a>
        <a href="#letra_M">M</a>
        <a href="#letra_O">O</a>
        <a href="#letra_P">P</a>
        <a href="#letra_R">R</a>
        <a href="#letra_S">S</a>
      </div>

      {/* Secciones */}
      <div id="letra_A">

        <Divider orientation="left">A</Divider>

        <Col span={16}>

          <h2>Acciones de difusión</h2>

          <p>
            Son acciones de promoción que llevan a cabo el Instituto Nacional Electoral (INE/Instituto), 
            a través de oficinas centrales, juntas locales ejecutivas (JLE) y juntas distritales ejecutivas (JDE), 
            y los Organismos Públicos Locales (OPL) a fin de incentivar la participación de la ciudadanía 
            como observadora electoral en los procesos electorales (PE) o mecanismos de participación ciudadana. 
            La difusión se puede realizar en diferentes medios de comunicación, por ejemplo: radio, televisión, 
            redes sociales, carteles, volantes, boletines de prensa, conferencias, entre otros.
          </p>

        </Col>

        <Col span={16}>

          <h2>Acreditación</h2>

          <p>
            Aprobación, por parte de los consejos locales (CL) y distritales (CD) del Instituto, 
            de las solicitudes presentadas por la ciudadanía que cumple con los requisitos establecidos en la ley, 
            para participar como observadora electoral.
          </p>

          {/* <p>
            Certificación o aprobación que brinda el Instituto Nacional
            Electoral (INE) a los ciudadanos, en este caso, para ser
            Observadores Electorales durante la Jornada Electoral. Para lo cual,
            se requiere cumplir con ciertos requisitos establecidos y validados
            por el INE, de tal forma que los ciudadanos dispongan de las
            capacidades y facultades necesarias para desempeñarse como
            Observadoras u observadores.
          </p> */}
         
        </Col>
        <Col span={16}>
          <h2>Afiliado o Militante</h2>

          <p>
            El o la ciudadana que, en pleno goce y ejercicio de sus derechos político-electorales, se registra libre, 
            voluntaria e individualmente a un partido político en los términos que para esos efectos disponga el partido 
            en su normatividad interna, independientemente de su denominación, actividad y grado de participación.
          </p>
        </Col>
      </div>

      <div id="letra_C">

        <Divider orientation="left">C</Divider>

        <Col span={16}>

          <h2>Candidata o candidato de partido político</h2>

          <p>
            Es la ciudadana o el ciudadano que se registra ante el INE o el OPL a través de un partido 
            político para participar en las elecciones buscando acceder a determinado cargo público. 
          </p>

        </Col>

        <Col span={16}>

          <h2>Candidata o candidato independiente</h2>
          <p>
            Es la ciudadana o el ciudadano no afiliado a un partido político que quiere acceder a un cargo 
            de elección popular y que, habiendo cumplido los requisitos, se registra ante la autoridad 
            electoral para competir por un cargo público.
          </p>

        </Col>

        <Col span={16}>

          <h2>Capacitadora / capacitador- Asistente Electoral (CAE)</h2>

          <p>
            Es la ciudadana o el ciudadano responsable, entre otras actividades, de notificar, entregar nombramientos y 
            capacitar a las y los ciudadanos que serán funcionarios de mesa directiva de casilla. 
          </p>

        </Col>

        <Col span={16}>

          <h2>Casilla</h2>

          <p>
            Es el lugar donde ciudadanas y ciudadanos acuden a votar, ahí las y los funcionarios que integran la 
            mesa directiva de casilla reciben, cuentan y registran los votos de las y los electores.
          </p>

        </Col>
      </div>

      <div id="letra_D">

        <Divider orientation="left">D</Divider>

        <h2>Distrito</h2>

        <Col span={16}>

          <p>
            Es la división geográfica en que se organiza el territorio de un país con fines electorales. 
            En él, se consideran los domicilios de los votantes para formar secciones electorales 
            donde se instala proporcionalmente un número de casillas para depositar el voto el día 
            de la Jornada Electoral.
          </p>

        </Col>

      </div>

      <div id="letra_E">

        <Divider orientation="left">E</Divider>

        <Col span={16}>

          <h2>Electora o elector</h2>
          <p>
            Es la ciudadana o el ciudadano que cuenta con Credencial para Votar y está inscrita o inscrito en la 
            Lista Nominal de Electores o en la lista adicional, o que le fue otorgada una resolución favorable del 
            Tribunal Electoral del Poder Judicial de la Federación, y acude a votar. 
          </p>

        </Col>

        <Col span={16}>

          <h2>Escrito bajo protesta</h2>

          <p>
            Documento necesario para realizar el registro para ser observador/a electoral, 
            donde las y los ciudadanos manifiesten que cumplen con los requisitos establecidos en el artículo 217, 
            numeral 1, inciso d) de la Ley General de Instituciones y Procedimientos Electorales (LGIPE).
          </p>

        </Col>
      </div>

      <div id="letra_F">

        <Divider orientation="left">F</Divider>

        <h2>Funcionarios/as de las mesas directivas de casillas</h2>

        <Col span={16}>
          <p>
            Es la ciudadanía seleccionada y capacitada por la autoridad electoral para 
            integrar las mesas directivas de casillas el día de la Jornada Electoral; así como recibir, contar, 
            clasificar y registrar los votos de las y los ciudadanos.
          </p>
        </Col>

      </div>

      <div id="letra_G">

        <Divider orientation="left">G</Divider>

        <Col span={16}>

          <h2>Grupos en situación de vulnerabilidad</h2>

          <p>
            Grupo de personas que se encuentra en una condición que sufre en su contra una conducta sistematizada 
            e incluso estandarizada de desprecio social debido a su pertenencia a un colectivo al que se le ha adherido 
            un estigma social que tiene como efecto un menoscabo de sus derechos.
          </p>

        </Col>

      </div>

      <div id="letra_I">

        <Divider orientation="left">I</Divider>

        <Col span={16}>

          <h2>Igualdad de género</h2>

          <p>
            Es la situación en la cual mujeres y hombres acceden con las mismas posibilidades y oportunidades al uso, 
            control y beneficio de bienes, servicios y recursos de la sociedad, así como a la toma de decisiones en todos 
            los ámbitos de la vida social, económica, política, cultural y familiar (Ley General para la Igualdad entre Mujeres y 
            Hombres en su artículo 5, fracción IV). 
          </p>

        </Col>

        <Col span={16}>

          <h2>Informes de observadoras y observadores</h2>

          <p>
            Documento que podrán entregar las y los observadores electorales que participaron en los PE o mecanismos de 
            participación ciudadana, mismo que podrá contener las actividades que observaron, así como las propuestas de 
            mejoras o problemáticas que identificaron. El informe se puede presentar en línea, a través del Portal de 
            observadoras y observadores Electorales (Portal Público), o de manera física al INE o los OPL.
          </p>

        </Col>
      </div>

      <div id="letra_J">

        <Divider orientation="left">J</Divider>

        <Col span={16}>

          <h2>Jornada Electoral</h2>

          <p>
            Es el día en el que las y los electores votan para elegir a sus representantes y gobernantes; 
            en este proceso electoral será el domingo {FECHA_JORNADA_ELECTORAL}.
          </p>

        </Col>

      </div>

      <div id="letra_L">

        <Divider orientation="left">L</Divider>

        <h2>Lista Nominal</h2>

        <Col span={16}>

          <p>
            Son las relaciones elaboradas por la Dirección Ejecutiva del Registro Federal de Electores 
            que contienen el nombre de las personas incluidas en el Padrón Electoral, agrupadas por distrito y sección, 
            a quienes se ha expedido y entregado su credencial para votar.
          </p>

        </Col>
      </div>

      <div id="letra_M">

        <Divider orientation="left">M</Divider>

        <Col span={16}>

          <h2>Medidas de inclusión</h2>

          <p>
            Acciones de carácter preventivo y/o correctivo dirigidas a revertir tendencias discriminatorias de la sociedad, 
            para incluir en el sistema de derechos y oportunidades a quienes han estado y están parcial o totalmente excluidos de sus libertades 
            como resultado de la discriminación histórica o experimentada. 
          </p>

        </Col>
      </div>

      <div id="letra_O">

        <Divider orientation="left">O</Divider>
        
        <Col span={16}>

          <h2>Observadores/as electorales</h2>

          <p>
            Son ciudadanas y ciudadanos mexicanos, facultados por la ley para observar los actos de preparación 
            y desarrollo del PE, así como los actos de la jornada electoral (JE). 
          </p>

        </Col>

        <Col span={16}>

          <h2>Organismos Públicos Locales (OPL)</h2>

          <p>
            Son los encargados de la organización de las elecciones en cada entidad federativa en los términos establecidos en 
            la Constitución Política de los Estados Unidos Mexicanos.
          </p>

        </Col>

        <Col span={16}>

          <h2>Organizaciones de observadores/as electorales</h2>

          <p>
            Organizaciones registradas y aprobadas para llevar a cabo procesos administrativos como es el registro de solicitudes 
            y la impartición de cursos, lo cual permita a las personas integrantes de la misma acreditarse como observadoras electorales.
          </p>

        </Col>
      </div>

      <div id="letra_P">

        <Divider orientation="left">P</Divider>

        <h2>Personas trans</h2>

        <Col span={16}>

          <p>
            Término utilizado para describir las diferentes variantes de las identidades de género y a grupos de población 
            específicos (travestis, transgénero y transexuales), cuyo denominador común es que el sexo asignado al nacer no 
            concuerda con la identidad de género de la persona. 
          </p>

        </Col>
      </div>

      <div id="letra_R">

        <Divider orientation="left">R</Divider>

        <Col span={16}>

          <h2>Ratificación</h2>

          <p>
            Figura contemplada para PE extraordinarios, que permite facilitar la acreditación de las personas 
            que participaron como observadoras electorales en el PE federal o local y desean participar nuevamente 
            como observadoras electorales en los procesos extraordinarios que deriven del PE para el cual se acreditó. 
            Con la ratificación, se exime a las personas de cumplir con el requisito del curso de capacitación; 
            sin embargo, se verifica que sigan cumpliendo con los demás requisitos establecidos en la ley.
          </p>

        </Col>
        <Col span={16}>

          <h2>Resolución favorable</h2>

          <p>
            Documento expedido por el Tribunal Electoral del Poder Judicial de la Federación mediante el cual se autoriza a la o 
            el ciudadano a ejercer su derecho al voto, ya sea porque solicitó su Credencial para Votar al INE y el Instituto no se la entregó, o 
            porque su nombre no aparece en la lista nominal o se le excluyó indebidamente de la misma. 
          </p>

        </Col>
      </div>

      <div id="letra_S">

        <Divider orientation="left">S</Divider>

        <Col span={16}>

          <h2>Supervisora/Supervisor Electoral (SE)</h2>

          <p>
            Es la ciudadana o el ciudadano que tiene a su cargo coordinar, apoyar y verificar las actividades realizadas por las y 
            los capacitadores-asistentes electorales. 
          </p>

        </Col>
      </div>
    </div>
  );
};

export default Glosario;
